export const partnerSpecializationCarouselTranslation = {
  label: 'cng-partner_specialization_carousel-label',
}
